export default __webpack_public_path__ + "static/media/Icons_RFID Icon.6e7713ca.svg";